import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { Observable } from 'rxjs';
import { NavigationItem } from 'src/@vex/interfaces/navigation-item.interface';

@Component({
  selector: 'vex-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  items$: Observable<NavigationItem[]>;

  constructor(private navigationService: NavigationService) { }

  ngOnInit() {
    this.items$ = this.navigationService.items$;
  }
}
